query GetPersistedListParams(
    $accountsSetting: String!
    $contactsSetting: String!
    $leadsSetting: String!
) {
    accounts: setting(settingName: $accountsSetting) {
        id
        value
    }
    contacts: setting(settingName: $contactsSetting) {
        id
        value
    }
    leads: setting(settingName: $leadsSetting) {
        id
        value
    }
}
